<div class="layout-container" [class.impersonating-active]="isImpersonating()">
  <app-festival-decoration></app-festival-decoration>
  @if (isImpersonating()) {
    <div
      class="impersonation-top-bar-global"
      [class.sidebar-collapsed]="layoutService.showSidebar() && layoutService.isSidebarCollapsed()"
      [class.no-sidebar]="!layoutService.showSidebar()"
      role="status"
      aria-live="polite"
    >
      <div class="impersonation-top-bar-global__inner">
        <span class="impersonation-top-bar-global__message">
          <span class="impersonation-top-bar-global__badge" aria-hidden="true">
            <i class="fas fa-user-shield"></i>
          </span>
          <span class="impersonation-top-bar-global__text">
            Viewing as
            <strong
              class="impersonation-top-bar-global__name"
              [matTooltip]="impersonatedUserName()"
              [matTooltipTruncateWhen]="!!impersonatedUserName()"
              matTooltipPosition="below"
            >
              {{ impersonatedUserName() }}
            </strong>
          </span>
        </span>
        <button
          type="button"
          class="impersonation-top-bar-global__switch-back"
          (click)="onSwitchBackToOriginalAccount()"
          [disabled]="switchBackLoading"
          [attr.aria-label]="impersonationSwitchBackTooltip()"
        >
          @if (switchBackLoading) {
            <app-spinner [size]="12"></app-spinner>
            <span>Switching…</span>
          } @else {
            <span>Sign out</span>
          }
        </button>
      </div>
    </div>
  }
  @if (layoutService.showSidebar()) {
  <app-sidebar [class.collapsed]="layoutService.isSidebarCollapsed()"
    [userInfoBg]="userInfoBg" [isChangePasswordOpen]="isChangePasswordOpen">
  </app-sidebar>
  }

  <div class="app_body" [class.sidebar-collapsed]="layoutService.isSidebarCollapsed()"
    [class.no-sidebar]="!layoutService.showSidebar()"
    [class.impersonating-active]="isImpersonating()">
    <app-header #headerComp (changePasswordClick)="onChangePasswordPanelToggled(true)"
      (accountSwitchedBack)="onAccountSwitchedBack()"
      (switchBackLoadingChange)="switchBackLoading = $event"
      (logoutLoadingChange)="onLogoutLoadingChange($event)"
      (backgroundImageSelected)="onBackgroundImageSelected($event)"
      (backgroundImagePreview)="onBackgroundImagePreview($event)" (themeBtnClick)="onThemeBtnClick()"
      (settingsClick)="onSettingsClick()" (profileDropdownStateChange)="onProfileDropdownStateChange($event)">
    </app-header>

    <main class="main_content" [class.full-width]="!layoutService.showSidebar() || layoutService.isSidebarCollapsed()"
      [class.has-right-sidebar]="shouldShowRightSidebar()"
      [class.right-sidebar-collapsed]="(layoutService.isRightSidebarCollapsed$ | async)">
      @if (thanksgivingBannerVisible()) {
      <section class="thanksgiving-note-banner" role="status" aria-live="polite">
        <div class="thanksgiving-note-banner__leaves" aria-hidden="true">
          @for (leaf of thanksgivingBannerLeaves; track $index) {
          <img
            class="thanksgiving-note-banner__leaf"
            [src]="leaf.src"
            alt=""
            draggable="false"
            [style.--leaf-left]="leaf.left"
            [style.--leaf-size]="leaf.size"
            [style.--leaf-duration]="leaf.duration"
            [style.--leaf-delay]="leaf.delay"
            [style.--leaf-drift]="leaf.drift"
            [style.--leaf-spin]="leaf.spin"
          />
          }
        </div>
        <img
          class="thanksgiving-note-banner__maple"
          src="assets/images/events/head-maple.png"
          alt=""
          aria-hidden="true"
          draggable="false"
        />
        <div class="thanksgiving-note-banner__copy">
          <p class="thanksgiving-note-banner__title">
            Happy Thanksgiving!
          </p>
          <img
            class="thanksgiving-note-banner__art"
            src="assets/images/events/thank-inner.png"
            alt=""
            aria-hidden="true"
            draggable="false"
          />
          <span class="thanksgiving-note-banner__divider" aria-hidden="true"></span>
          <p class="thanksgiving-note-banner__message">
            May your day be full of warmth, laughter, and the people who matter most.
          </p>
        </div>
        <button
          type="button"
          class="thanksgiving-note-banner__close"
          aria-label="Dismiss Thanksgiving message"
          (click)="dismissThanksgivingBanner()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </section>
      }
      @if (halloweenBannerVisible()) {
      <section class="halloween-note-banner" role="status" aria-live="polite">
        <div class="halloween-note-banner__scene" aria-hidden="true">
          <img
            class="halloween-note-banner__moon"
            src="assets/images/events/half moon.png"
            alt=""
            draggable="false"
          />
          <span class="halloween-note-banner__hills"></span>
          <span class="halloween-note-banner__stars"></span>
        </div>
        <div class="halloween-note-banner__bats" aria-hidden="true">
          @for (bat of halloweenBannerBats; track $index) {
          <img
            class="halloween-note-banner__bat"
            [class.halloween-note-banner__bat--a]="bat.path === 'a'"
            [class.halloween-note-banner__bat--b]="bat.path === 'b'"
            [class.halloween-note-banner__bat--c]="bat.path === 'c'"
            src="assets/images/events/halloween-ybat.gif"
            alt=""
            draggable="false"
            [style.--bat-left]="bat.left"
            [style.--bat-top]="bat.top"
            [style.--bat-size]="bat.size"
            [style.--bat-duration]="bat.duration"
            [style.--bat-delay]="bat.delay"
          />
          }
        </div>
        <img
          class="halloween-note-banner__ghost"
          src="assets/images/events/hallo-ghost.gif"
          alt=""
          aria-hidden="true"
          draggable="false"
        />
        <div class="halloween-note-banner__copy">
          <p class="halloween-note-banner__title">Happy Halloween!</p>
          <span class="halloween-note-banner__divider" aria-hidden="true"></span>
          <p class="halloween-note-banner__message">
            May your day be bright with good cheer, bold ideas, and just a touch of spooky fun.
          </p>
        </div>
        <button
          type="button"
          class="halloween-note-banner__close"
          aria-label="Dismiss Halloween message"
          (click)="dismissHalloweenBanner()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </section>
      }
      @if (fallBannerVisible()) {
      <section class="fall-note-banner" role="status" aria-live="polite">
        <img
          class="fall-note-banner__scene"
          src="assets/images/events/fall-of-summer.png"
          alt=""
          aria-hidden="true"
          draggable="false"
        />
        <div class="fall-note-banner__leaves" aria-hidden="true">
          @for (leaf of thanksgivingBannerLeaves; track $index) {
          <img
            class="fall-note-banner__leaf"
            [src]="leaf.src"
            alt=""
            draggable="false"
            [style.--leaf-left]="leaf.left"
            [style.--leaf-size]="leaf.size"
            [style.--leaf-duration]="leaf.duration"
            [style.--leaf-delay]="leaf.delay"
            [style.--leaf-drift]="leaf.drift"
            [style.--leaf-spin]="leaf.spin"
          />
          }
        </div>
        <img
          class="fall-note-banner__character"
          src="assets/images/events/thank-inner.png"
          alt=""
          aria-hidden="true"
          draggable="false"
        />
        <div class="fall-note-banner__copy">
          <p class="fall-note-banner__title">Hello, Fall!</p>
          <span class="fall-note-banner__divider" aria-hidden="true"></span>
          <p class="fall-note-banner__message">
            A new season is here — may it bring fresh energy, cozy days, and a little extra color.
          </p>
        </div>
        <button
          type="button"
          class="fall-note-banner__close"
          aria-label="Dismiss fall greeting"
          (click)="dismissFallBanner()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </section>
      }
      @if (remembranceBannerVisible()) {
      <section class="remembrance-note-banner" role="status" aria-live="polite">
       
        <div class="remembrance-note-banner__poppies" aria-hidden="true">
          @for (petal of remembranceBannerPoppies; track $index) {
          <img
            class="remembrance-note-banner__petal"
            [src]="petal.src"
            alt=""
            draggable="false"
            [style.--leaf-left]="petal.left"
            [style.--leaf-size]="petal.size"
            [style.--leaf-duration]="petal.duration"
            [style.--leaf-delay]="petal.delay"
            [style.--leaf-drift]="petal.drift"
            [style.--leaf-spin]="petal.spin"
          />
          }
        </div>
        <img
          class="remembrance-note-banner__character"
          src="assets/images/events/rem.png"
          alt=""
          aria-hidden="true"
          draggable="false"
        />
        <div class="remembrance-note-banner__copy">
          <p class="remembrance-note-banner__title">We Remember</p>
          <span class="remembrance-note-banner__divider" aria-hidden="true"></span>
          <p class="remembrance-note-banner__message">
            Lest we forget. Today we honour those who served, and the peace they helped protect.
          </p>
        </div>
        <button
          type="button"
          class="remembrance-note-banner__close"
          aria-label="Dismiss Remembrance Day message"
          (click)="dismissRemembranceBanner()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </section>
      }
      <div class="content_wrapper">
        @for (sessionKey of [pageSessionKey()]; track sessionKey) {
          <router-outlet></router-outlet>
        }
      </div>

      <!-- Mobile Quick Add Button - Show on screens 1023px and below -->
      <button class="mobile_quick_add radial_menu_btn" (click)="onMobileAddClick()"
        [class.active]="isMobileRadialMenuOpen">
        <img src="assets/images/quick.svg" alt="Add">
        <div class="quick_add_text">
          GET STARTED
        </div>
      </button>

      <div class="right_container">
        <!-- Client Summary Button - Only show on project-details page -->
        @if (shouldShowRightSidebar()) {
        <app-right-sidebar class="right_sidebar"></app-right-sidebar>
        }
      </div>

    </main>

    <app-footer></app-footer>

    <app-ai-help-assistant-panel />
  </div>
</div>

<!-- Change Password Form - Rendered at layout level to cover entire viewport -->
@if (isChangePasswordOpen) {
<app-change-password-form 
  [forceRequired]="passwordResetRequired()"
  (close)="onChangePasswordPanelToggled(false)"></app-change-password-form>
}

<!-- Theme Selection Modal - Rendered at layout level to cover entire viewport -->
@if (themeSelectionModalOpen) {
<app-theme-selection-modal (close)="onCloseThemeSelectionModal()"
  (themeSelected)="onThemeSelected($event)" (themeToggled)="onThemeToggled($event)"
  (themePreview)="onThemePreview($event)">
</app-theme-selection-modal>
}

<!-- My Settings Modal - Rendered at layout level to cover entire viewport -->
@if (showSettingsSlider) {
<app-my-settings (close)="onCloseSettingsSlider()" (settingsSaved)="onSettingsSaved($event)">
</app-my-settings>
}

<!-- Profile Dropdown - Rendered at layout level to appear above right sidebar -->
@if (profileDropdownOpen) {
<div class="profile-dropdown-global">
  <div class="user-info">
    <a class="name" (click)="navigateToProfileView($event)" style="cursor: pointer;">{{profileDropdownUserName}}</a>
  </div>
  @if (isImpersonating()) {
  <button class="dropdown-item switch-back-account" (click)="onSwitchBackToOriginalAccount()"
    [disabled]="switchBackLoading || logoutLoading">
    @if (switchBackLoading) {
    <app-spinner [size]="16"></app-spinner>
    <span>Switching...</span>
    } @else {
    <i class="fas fa-user-shield"></i>
    <span>Back to {{ originalAccountName() }}</span>
    }
  </button>
  <div class="dropdown-divider"></div>
  }
  <a class="dropdown-item dropdown-item--my-settings" (click)="onSettingsClick()"
    [class.disabled]="logoutLoading">
    <i class="wl_icon_settings"></i>
    My Settings
  </a>
  <button class="dropdown-item dropdown-item--theme" (click)="onThemeBtnClick()"
    [disabled]="logoutLoading">
    <i class="fas fa-palette"></i>
    Theme
  </button>
  <button class="dropdown-item" (click)="onChangePasswordPanelToggled(true)"
    [disabled]="logoutLoading">
    <i class="fas fa-key"></i>
    Change Password
  </button>
 
  <!-- @if (canSeeSetupLinks) {
  <button class="dropdown-item" type="button" (click)="navigateFromProfileDropdown('/setup/master-approval-listing')"
    [disabled]="logoutLoading">
    <i class="wl_icon_approvals"></i>
    Master Approvals
  </button>
  <button class="dropdown-item" type="button" (click)="navigateFromProfileDropdown('/setup/request-queues')"
    [disabled]="logoutLoading">
    <i class="wl_icon_queues"></i>
     Queues
  </button>
  <div class="dropdown-divider"></div>
  } -->
  <div class="dropdown-divider"></div>
  <button
    class="dropdown-item dropdown-item--sign-out"
    type="button"
    (click)="onLogoutClick($event)"
    [disabled]="logoutLoading"
  >
    @if (logoutLoading) {
    <app-spinner [size]="16"></app-spinner>
    <span>Signing out...</span>
    } @else {
    <i class="fas fa-sign-out-alt"></i>
    <span>Sign Out</span>
    }
  </button>
</div>
}

@if (popupViews().length > 0) {
<div class="popup-notifications-container">
  @for (view of popupViews(); track view.popup.id; let i = $index) {
    <div class="notification-popup" [class.show]="view.popup.showPopup" [style.bottom.px]="0 + (i * 250)"
      (click)="onPopupClick(view.popup, $event)"
      (mouseenter)="pausePopupAutoDismiss(view.popup.id)"
      (mouseleave)="resumePopupAutoDismiss(view.popup.id)">
      <button class="popup-close" (click)="dismissPopup(view.popup.id, $event)" title="Dismiss">
        <i class="fas fa-times"></i>
      </button>

      <div class="popup-main-content">
        <div class="popup-identity">
          <div class="popup-avatar-wrapper">
            @if (view.popup.user.avatar && !imageLoadError[view.popup.id]) {
            <img [src]="view.popup.user.avatar" [alt]="view.popup.user.name"
              class="popup-avatar" (error)="onImageError(view.popup.id)" (load)="onImageLoad(view.popup.id)">
            }
            @if (!view.popup.user.avatar || imageLoadError[view.popup.id]) {
            <div class="popup-avatar-fallback">
              {{ view.initials }}
            </div>
            }
            <div class="status-indicator"></div>
          </div>
          <h3 class="popup-user-name">{{ view.popup.user.name }}</h3>
        </div>

        <div class="popup-content">
          @if (view.messagePrefix || view.objectName) {
          <p class="popup-title" [title]="view.readableMessage">
            @if (view.messagePrefix) {
            <span class="popup-title-prefix">{{ view.messagePrefix }}</span>
            }
            @if (view.objectName) {
              @if (view.canOpenObject && view.objectRouterLink) {
              <a class="popup-object-link"
                [routerLink]="view.objectRouterLink"
                [queryParams]="view.objectQueryParams"
                [fragment]="view.objectFragment"
                [title]="'Open ' + view.objectName"
                (click)="onPopupObjectLinkClick(view.popup, $event)">{{ view.objectName }}</a>
              } @else {
              <span class="popup-object-name">{{ view.objectName }}</span>
              }
            }
          </p>
          }
          @if (view.hasMeta) {
          <div class="popup-meta-list">
            @if (view.dateTime) {
            <div class="popup-meta-row" [title]="view.dateTime">
              <i class="wl_icon_date popup-meta-icon" aria-hidden="true"></i>
              <div class="popup-meta-copy">
                <span class="popup-meta-label">Date and time</span>
                <span class="popup-meta-value">{{ view.dateTime }}</span>
              </div>
            </div>
            }
            @if (view.projectLine) {
            <div class="popup-meta-row" [title]="view.projectLine">
              <i class="wl_icon_active-pro popup-meta-icon" aria-hidden="true"></i>
              <div class="popup-meta-copy">
                <span class="popup-meta-label">Project</span>
                @if (view.projectRoute; as projectRoute) {
                <a class="popup-meta-value popup-object-link"
                  [routerLink]="projectRoute"
                  [title]="'Open project: ' + view.projectLine"
                  (click)="onPopupObjectLinkClick(view.popup, $event)">{{ view.projectLine }}</a>
                } @else {
                <span class="popup-meta-value">{{ view.projectLine }}</span>
                }
              </div>
            </div>
            }
            @if (view.clientLine) {
            <div class="popup-meta-row" [title]="view.clientLine">
              <i class="wl_icon_clients popup-meta-icon" aria-hidden="true"></i>
              <div class="popup-meta-copy">
                <span class="popup-meta-label">Client</span>
                <span class="popup-meta-value">{{ view.clientLine }}</span>
              </div>
            </div>
            }
            @if (view.serviceLine) {
            <div class="popup-meta-row" [title]="view.serviceLine">
              <i class="wl_icon_type popup-meta-icon" aria-hidden="true"></i>
              <div class="popup-meta-copy">
                <span class="popup-meta-label">Service</span>
                <span class="popup-meta-value">{{ view.serviceLine }}</span>
              </div>
            </div>
            }
          </div>
          }
        </div>
      </div>

      <div class="popup-actions">
        <!-- Show check icon for unread, double-tick for read -->
        @if (!view.popup.isRead) {
        <button class="popup-action-btn" (click)="markAsRead(view.popup); $event.stopPropagation()"
          title="Mark as read">
          <i class="wl_icon_comment-check"></i>
        </button>
        }
        @if (view.popup.isRead) {
        <button class="popup-action-btn read-indicator" title="Read">
          <i class="wl_icon_calendar-check"></i>
        </button>
        }

        <!-- Three dots dropdown -->
        <div class="popup-dropdown-container">
          <button class="popup-action-btn" (click)="togglePopupDropdown(view.popup.id, $event)" title="More options">
            <i class="wl_icon_doc-3dot"></i>
          </button>

          <!-- Dropdown Menu -->
          @if (isPopupDropdownOpen(view.popup.id)) {
          <div class="popup-dropdown" (click)="$event.stopPropagation()"
            [class.dropdown-open]="isPopupDropdownOpen(view.popup.id)">

            <!-- View Details -->
            <button class="dropdown-item" (click)="onPopupDropdownItemClick(view.popup, 'view-details', $event)">
              <i class="wl_icon_client-quick"></i>
              <span>View Details</span>
            </button>

            <!-- Divider -->
            <div class="dropdown-divider"></div>

          </div>
          }
        </div>
      </div>

      <!-- Countdown Progress Bar -->
      @if (view.popup.showPopup && !view.popup.isPinned) {
      <div class="notification-countdown-bar" [style.animation-duration]="view.popup.popupTimeout + 'ms'">
      </div>
      }
    </div>
    }
</div>
}

<!-- Test button for popup notifications (can be removed later) -->
<!-- <button class="test-notification-popup-btn" (click)="testAddNotification()" title="Test Notification Popup">
  <i class="fas fa-bell"></i>
  Test Popup
</button> -->

<!-- Mobile Radial Menu Overlay -->
<div class="mobile_radial_menu_overlay" [class.active]="isMobileRadialMenuOpen" (click)="onMobileRadialMenuClose($event)"></div>

<!-- Mobile Radial Menu -->
<div class="mobile_radial_menu" [class.open]="isMobileRadialMenuOpen" (click)="$event.stopPropagation()">
  <!-- Close Button -->
  <button class="radial_menu_close_btn" (click)="onMobileRadialMenuClose($event)" aria-label="Close menu">
    <!-- <img src="assets/images/quick.svg" alt="Add"> -->
     <mat-icon>close</mat-icon>
  </button>

  <div class="mobile_menu_header">
    <h3>Get Started
    </h3>
  </div>

  <!-- Radial Menu Items -->
  <div class="radial_menu_items">
    @for (item of mobileRadialMenuItems; track item.label; let i = $index) {
    <div class="radial_menu_item" [style.--item-index]="i"
      (click)="onMobileRadialMenuItemClick(item, $event)" [attr.data-tooltip]="item.label">
      <div class="radial_item_content">
        <div class="radial_icon_wrapper">
          <img [src]="item.icon" [alt]="item.label">
        </div>
        <span class="radial_item_label">{{ item.label }}</span>
      </div>
    </div>
    }
  </div>
</div>
<app-timesheet-submission-required-popup
  [show]="timesheetSubmissionPopupShow()"
  [appendToBody]="true"
  title="Timesheet submission required"
  [message]="timesheetSubmissionPopupMessage()"
  [totalHours]="timesheetSubmissionPopupHours()"
  [hoursLoading]="timesheetStatusService.lastWeekFilledHoursLoading()"
  confirmText="Go to Timesheet"
  (confirm)="onTimesheetSubmissionPopupConfirm()"
  (closed)="onTimesheetSubmissionPopupCancel()">
</app-timesheet-submission-required-popup>
<!-- Notification attachment preview (header dropdown + sidebar panel) -->
<app-image-preview-modal
  [isOpen]="notificationAttachmentPreview.isImageModalOpen"
  [imageUrl]="notificationAttachmentPreview.selectedImageUrl"
  [imageTitle]="notificationAttachmentPreview.selectedImageTitle"
  [fileSize]="notificationAttachmentPreview.selectedImageSize"
  [downloadUrl]="notificationAttachmentPreview.selectedImageDownloadUrl"
  [uploadedAt]="notificationAttachmentPreview.selectedImageUploadedAt"
  [downloadProgress]="notificationAttachmentPreview.downloadProgress"
  (close)="notificationAttachmentPreview.closeImageModal()"
  (download)="notificationAttachmentPreview.onImageDownload($event)"
  (share)="notificationAttachmentPreview.onImageShare($event)"
>
</app-image-preview-modal>

<app-media-preview-modal
  [isOpen]="notificationAttachmentPreview.isMediaModalOpen"
  [mediaUrl]="notificationAttachmentPreview.selectedMediaUrl"
  [mediaTitle]="notificationAttachmentPreview.selectedMediaTitle"
  [fileSize]="notificationAttachmentPreview.selectedMediaSize"
  [mediaType]="notificationAttachmentPreview.selectedMediaType"
  [webViewLink]="notificationAttachmentPreview.selectedMediaWebViewLink"
  [downloadProgress]="notificationAttachmentPreview.downloadProgress"
  (close)="notificationAttachmentPreview.closeMediaModal()"
  (download)="notificationAttachmentPreview.onMediaDownload($event)"
  (share)="notificationAttachmentPreview.onMediaShare($event)"
>
</app-media-preview-modal>
